import { Link } from "react-router-dom";
import { Mail, MapPin, Instagram, Facebook, Heart } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#292522] text-[#FFFCF8] mt-24" data-testid="site-footer">
      <div className="container-vv py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo variant="dark" size="xl" />
            <p className="mt-5 text-sm leading-relaxed text-[#FFFCF8]/70 max-w-xs">
              Associazione di promozione sociale che crea occasioni di incontro, partecipazione e crescita per famiglie e comunità.
            </p>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#FFFCF8]/10 px-3 py-1.5 text-xs">
              <span className="h-1.5 w-1.5 rounded-full bg-[#FF6100]" /> Affiliata ARCI · Iscritta al RUNTS
              <span className="text-[#FFFCF8]/50">(n° iscrizione da inserire)</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-[#FF6100]">Contatti</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex gap-2"><MapPin className="h-4 w-4 shrink-0 mt-0.5" strokeWidth={1.5} /> Via Galliera 2/A<br />40013 Castel Maggiore (BO)</li>
              <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0 mt-0.5" strokeWidth={1.5} /> <a className="hover:text-[#FF6100]" href="mailto:volavolaaps@gmail.com" data-testid="footer-email">volavolaaps@gmail.com</a></li>
            </ul>
            <div className="mt-4 flex gap-2">
              <a href="#" aria-label="Instagram" className="h-9 w-9 rounded-full bg-[#FFFCF8]/10 hover:bg-[#FF6100] flex items-center justify-center transition-colors"><Instagram className="h-4 w-4" strokeWidth={1.5} /></a>
              <a href="#" aria-label="Facebook" className="h-9 w-9 rounded-full bg-[#FFFCF8]/10 hover:bg-[#FF6100] flex items-center justify-center transition-colors"><Facebook className="h-4 w-4" strokeWidth={1.5} /></a>
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-[#FF6100]">Esplora</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/chi-siamo" className="hover:text-[#FF6100]">Chi siamo</Link></li>
              <li><Link to="/cosa-facciamo" className="hover:text-[#FF6100]">Cosa facciamo</Link></li>
              <li><Link to="/progetti" className="hover:text-[#FF6100]">Progetti</Link></li>
              <li><Link to="/eventi" className="hover:text-[#FF6100]">Eventi</Link></li>
              <li><Link to="/reti-e-collaborazioni" className="hover:text-[#FF6100]">Reti e collaborazioni</Link></li>
              <li><Link to="/storie" className="hover:text-[#FF6100]">Storie e risorse</Link></li>
              <li><Link to="/contatti" className="hover:text-[#FF6100]">Contatti</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-[#FF6100]">Partecipa</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/partecipa#socio" className="hover:text-[#FF6100]">Diventa socio/a</Link></li>
              <li><Link to="/partecipa#volontariato" className="hover:text-[#FF6100]">Fai volontariato</Link></li>
              <li><Link to="/partecipa#cinquepermille" className="hover:text-[#FF6100] font-semibold">Dona il 5×1000</Link></li>
              <li><Link to="/partecipa#sostieni" className="hover:text-[#FF6100]">Sostieni Vola Vola</Link></li>
              <li><Link to="/partecipa#collabora" className="hover:text-[#FF6100]">Collabora con noi</Link></li>
            </ul>
          </div>
        </div>

        <hr className="my-10 border-[#FFFCF8]/10" />

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[#FFFCF8]/60">
          <div className="space-y-1">
            <div>© {new Date().getFullYear()} Vola Vola APS · Castel Maggiore (BO)</div>
            <div>C.F. 91436320377</div>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/privacy" className="hover:text-[#FF6100]">Privacy Policy</Link>
            <Link to="/cookie" className="hover:text-[#FF6100]">Cookie Policy</Link>
            <Link to="/accedi" className="hover:text-[#FF6100]" data-testid="footer-accedi-link">Area riservata</Link>
          </div>
        </div>
        <div className="mt-8 flex items-center gap-1.5 text-[11px] text-[#FFFCF8]/40">
          Fatto con <Heart className="h-3 w-3 text-[#FF6100]" fill="#FF6100" /> per la comunità
        </div>
      </div>
    </footer>
  );
}
